import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/feature/MovieCard';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ScrollToTop from '@/components/base/ScrollToTop';
import { movies, categories } from '@/mocks/movies';
import { articles } from '@/mocks/articles';
import { useState } from 'react';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [showAllFeatured, setShowAllFeatured] = useState(false);

  const hotMovies = movies.filter(m => m.isHot);
  const newMovies = movies.filter(m => m.isNew);
  const filteredMovies = activeCategory === 'all'
    ? movies
    : movies.filter(m => m.categorySlug === activeCategory);

  const displayedFeatured = showAllFeatured ? hotMovies : hotMovies.slice(0, 4);

  const websiteSchema = {
    name: '久久影视',
    url: 'https://www.jiujiutv.com',
    description: '久久影视提供高清免费影视在线观看，聚合海量免费高清电影、高清电视剧，画质清晰不缓冲，零成本畅享高清视听盛宴。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.jiujiutv.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    mainEntity: [
      {
        '@type': 'Question',
        name: '久久影视需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久影视完全免费，无需任何付费即可畅享全部高清影视内容，真正做到零成本在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '久久影视的画质怎么样？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久影视所有影视资源均为高清画质，采用先进的视频编码技术，播放流畅不缓冲，为您提供极致的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '久久影视有哪些影视类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久影视涵盖电影、电视剧、动漫、综艺等多种类型，汇聚海量国内外优质影视内容，满足不同观众的观影需求。',
        },
      },
      {
        '@type': 'Question',
        name: '久久影视可以在手机上观看吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！久久影视完美适配手机、平板、电脑等多种设备，随时随地畅享高清影视体验。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '久久影视 - 高清影视在线免费看 | 免费高清电影与高清电视剧免费看大全',
          description: '久久影视提供高清免费影视在线观看，聚合海量免费高清电影、高清电视剧，画质清晰不缓冲，零成本畅享高清视听盛宴。',
          url: 'https://www.jiujiutv.com/',
          isPartOf: { '@type': 'WebSite', name: '久久影视', url: 'https://www.jiujiutv.com' },
        }}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20stage%20curtains%20and%20projector%20light%20beams%2C%20luxurious%20velvet%20seats%2C%20atmospheric%20lighting%2C%20rich%20dark%20tones%20with%20warm%20amber%20highlights%2C%20elegant%20and%20dramatic%20composition%2C%20premium%20cinema%20experience%20aesthetic&width=1920&height=900&seq=hero-bg-home&orientation=landscape"
            alt="久久影视 - 高清影视在线免费观看"
            title="久久影视 - 高清影视在线免费看 | 免费高清电影与高清电视剧免费看大全"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />

          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight mb-4">
                  高清影视在线<span className="text-primary-500">免费看</span>
                </h1>
                <p className="text-base md:text-lg text-foreground-300 mb-8 max-w-2xl mx-auto leading-relaxed">
                  久久影视为您聚合海量免费高清电影、高清电视剧，画质清晰不缓冲，零成本畅享高清视听盛宴
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/movies"
                    className="px-8 py-3 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <span className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-film-line text-sm"></i>
                      </div>
                      浏览电影
                    </span>
                  </Link>
                  <Link
                    to="/category/tv-shows"
                    className="px-8 py-3 rounded-full bg-background-50/10 text-foreground-50 font-medium text-sm border border-foreground-50/20 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <span className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-tv-line text-sm"></i>
                      </div>
                      热播剧集
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
            <div className="w-8 h-8 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-s-line text-foreground-50/60 text-xl"></i>
            </div>
          </div>
        </section>

        {/* Category Quick Nav */}
        <section className="py-6 md:py-8 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      cat.slug === 'all'
                        ? 'bg-primary-500 text-background-950'
                        : 'bg-background-200 text-foreground-400 hover:text-foreground-50 hover:bg-background-300'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Hot Picks Section */}
        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                    <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                      <i className="ri-fire-line text-accent-500 text-lg"></i>
                    </div>
                    热门推荐
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">精选高分热门影视，大家都在看</p>
                </div>
                <button
                  onClick={() => setShowAllFeatured(!showAllFeatured)}
                  className="text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1"
                >
                  {showAllFeatured ? '收起' : '查看全部'}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-xs ${showAllFeatured ? 'ri-arrow-up-s-line' : 'ri-arrow-right-s-line'}`}></i>
                  </div>
                </button>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                {displayedFeatured.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter Section */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                  <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                    <i className="ri-grid-line text-primary-500 text-lg"></i>
                  </div>
                  影视大全
                </h2>
                <p className="text-sm text-foreground-500 mt-1">按分类浏览海量高清影视资源</p>
              </div>

              <div className="flex items-center gap-2 mb-6 flex-wrap">
                {categories.map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => setActiveCategory(cat.slug)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      activeCategory === cat.slug
                        ? 'bg-primary-500 text-background-950'
                        : 'bg-background-200 text-foreground-400 hover:text-foreground-50'
                    }`}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>

              {filteredMovies.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                  {filteredMovies.map((movie) => (
                    <MovieCard key={movie.id} movie={movie} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                    <i className="ri-emotion-sad-line text-foreground-500 text-2xl"></i>
                  </div>
                  <p className="text-foreground-500 text-sm">暂无该分类的影视内容</p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                  <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                    <i className="ri-sparkling-line text-primary-500 text-lg"></i>
                  </div>
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500 mt-1">刚刚更新的新鲜内容，快来尝鲜</p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                {newMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                  <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                    <i className="ri-article-line text-primary-500 text-lg"></i>
                  </div>
                  影视资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最新影视资讯、深度影评、观影指南</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {articles.slice(0, 3).map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group cursor-pointer rounded-lg overflow-hidden bg-background-200 hover:bg-background-300/50 transition-colors duration-200"
                  >
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="px-2 py-0.5 text-[10px] rounded bg-accent-100 text-accent-900 whitespace-nowrap">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-600">{article.date}</span>
                      </div>
                      <h3 className="text-sm font-heading font-medium text-foreground-50 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                        {article.summary}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-3">
                  为什么选择<strong className="text-primary-500">久久影视</strong>？
                </h2>
                <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                  我们致力于为您提供最好的在线观影体验
                </p>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {[
                  { icon: 'ri-4k-line', title: '高清画质', desc: '全站高清片源，支持超清画质播放' },
                  { icon: 'ri-flashlight-line', title: '极速不缓冲', desc: '先进CDN加速，播放流畅不卡顿' },
                  { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '无需付费会员，零成本畅享' },
                  { icon: 'ri-smartphone-line', title: '多端适配', desc: '手机平板电脑，随时随地观看' },
                ].map((feature) => (
                  <div key={feature.title} className="text-center p-5 rounded-lg bg-background-100">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                      <i className={`${feature.icon} text-primary-500 text-xl`}></i>
                    </div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-50 mb-1">{feature.title}</h3>
                    <p className="text-xs text-foreground-500">{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-14 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20golden%20light%20streaks%20and%20particles%2C%20luxurious%20theater%20atmosphere%2C%20rich%20dark%20and%20amber%20color%20palette%2C%20elegant%20and%20dramatic%20design%2C%20premium%20cinematic%20aesthetic&width=1920&height=600&seq=cta-bg-home&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
          <div className="relative w-full px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-4">
                即刻开启<span className="text-primary-500">免费观影</span>之旅
              </h2>
              <p className="text-sm text-foreground-300 mb-6 leading-relaxed">
                海量高清影视资源，电影、电视剧、动漫、综艺应有尽有，无需注册即可免费在线观看
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line text-sm"></i>
                </div>
                开始观看
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}